import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as Actions from "../../../../../store/modules/category";
import Category2 from "../../../../../components/admin/type/category"

class TempCategories extends Component {
	constructor(props) {
		super(props);

		this.state = {
			category: [],
			setDataList: [],
			isOpenChild: true,
			editIndex: '',
			pkKey: 'category_id',
			isInit: false,
			depth: 1,
			action: "category/dept",
		}
	}

	render() {
		return (
			<Category2
				title="학과"
				type="dept"
			/>
		)
	}
}

// export default Code;

export default connect(
	(state) => ({
		param: state.category.param ? state.category.param : {},
		category: state.category.category ? state.category.category : [],
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(TempCategories)